// // JobApplicationForm.jsx
// import React, { useRef, useState } from 'react';
// import { useReactToPrint } from 'react-to-print';
// import html2pdf from 'html2pdf.js';

// const JobApplicationForm = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     // Personal Details
//     positionAppliedFor: '',
//     title: '',
//     surname: '',
//     firstName: '',
//     otherNames: '',
//     address: '',
//     email: '',
//     phoneNumber: '',
//     preferredContact: '',
//     unavailableDates: '',
//     eligibleNigeria: '',
//     eligibilityDocuments: '',
//     criminalConvictions: '',
//     unspentConvictionsDetails: '',
    
//     // Employment History (Current)
//     currentEmployerName: '',
//     currentEmployerAddress: '',
//     natureOfBusiness: '',
//     jobTitle: '',
//     dateJoined: '',
//     dateStartedCurrent: '',
//     noticePeriod: '',
//     currentSalary: '',
//     mainTasks: '',
//     reasonForLeaving: '',
    
//     // Employment History (Continued) - Array for multiple entries
//     employmentHistory: [
//       { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }
//     ],
    
//     // Education
//     secondarySchool: '',
//     secondaryExams: '',
//     secondaryGrades: '',
//     furtherEducation: '',
//     professionalOrg: '',
//     gradeOfMembership: '',
//     jobTraining: '',
    
//     // Skills
//     skillsInfo: '',
    
//     // References
//     ref1Name: '',
//     ref1Company: '',
//     ref1Address: '',
//     ref1JobTitle: '',
//     ref1Relationship: '',
//     ref1Phone: '',
//     ref1Fax: '',
//     ref1Email: '',
//     ref2Name: '',
//     ref2Company: '',
//     ref2Address: '',
//     ref2JobTitle: '',
//     ref2Relationship: '',
//     ref2Phone: '',
//     ref2Fax: '',
//     ref2Email: '',
    
//     // Declaration
//     signature: '',
//     date: '',
//   });

//   const componentRef = useRef();

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleEmploymentHistoryChange = (index, field, value) => {
//     const updatedHistory = formData.employmentHistory.map((item, i) =>
//       i === index ? { ...item, [field]: value } : item
//     );
//     setFormData(prev => ({ ...prev, employmentHistory: updatedHistory }));
//   };

//   // Print functionality using react-to-print
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//   });

//   // Download as PDF using html2pdf
//   const handleDownload = () => {
//     const element = componentRef.current;
//     const opt = {
//       margin: 1,
//       filename: 'Job_Application_Form.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//     };
//     html2pdf().set(opt).from(element).save();
//   };

//   // Add more employment history entries
//   const addEmploymentEntry = () => {
//     setFormData(prev => ({
//       ...prev,
//       employmentHistory: [...prev.employmentHistory, { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }]
//     }));
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white p-8 m-4 max-w-4xl max-h-screen overflow-y-auto rounded-lg shadow-xl">
//         <div className="flex justify-between items-center mb-6">
//           <h1 className="text-2xl font-bold text-gray-800">Job Application Form</h1>
//           <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
//         </div>

//         {/* Print/Download Buttons */}
//         <div className="flex gap-4 mb-6">
//           <button
//             onClick={handlePrint}
//             className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
//           >
//             Print Form
//           </button>
//           <button
//             onClick={handleDownload}
//             className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
//           >
//             Download PDF
//           </button>
//         </div>

//         {/* Form Content - Ref for Print/Download */}
//         <div ref={componentRef} className="space-y-8">
//           {/* Position Applied For */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Position Applied For</h2>
//             <input
//               type="text"
//               name="positionAppliedFor"
//               value={formData.positionAppliedFor}
//               onChange={handleInputChange}
//               className="w-full p-2 border border-gray-300 rounded mt-2"
//               placeholder="Enter position applied for"
//             />
//           </div>

//           {/* Personal Details */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Personal Details</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Title (Mr/Mrs/Miss/Ms)</label>
//                 <input type="text" name="title" value={formData.title} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Surname</label>
//                 <input type="text" name="surname" value={formData.surname} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">First Name(s)</label>
//                 <input type="text" name="firstName" value={formData.firstName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Any Other Names</label>
//                 <input type="text" name="otherNames" value={formData.otherNames} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Address</label>
//                 <textarea name="address" value={formData.address} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Email Address</label>
//                 <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Phone Number</label>
//                 <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Preferred Contact Method</label>
//                 <input type="text" name="preferredContact" value={formData.preferredContact} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Dates Not Available for Interview</label>
//                 <textarea name="unavailableDates" value={formData.unavailableDates} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="2" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Eligible for Employment in Nigeria?</label>
//                 <select name="eligibleNigeria" value={formData.eligibleNigeria} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded">
//                   <option value="">Select</option>
//                   <option value="YES">YES</option>
//                   <option value="NO">NO</option>
//                 </select>
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Documents for Eligibility</label>
//                 <textarea name="eligibilityDocuments" value={formData.eligibilityDocuments} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Criminal Convictions (Unspent)?</label>
//                 <select name="criminalConvictions" value={formData.criminalConvictions} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded">
//                   <option value="">Select</option>
//                   <option value="YES">YES</option>
//                   <option value="NO">NO</option>
//                 </select>
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Details of Unspent Convictions</label>
//                 <textarea name="unspentConvictionsDetails" value={formData.unspentConvictionsDetails} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
//               </div>
//             </div>
//           </div>

//           {/* Employment History (Current) */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Employment History - Current/Previous Employer</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Name of Company</label>
//                 <input type="text" name="currentEmployerName" value={formData.currentEmployerName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Address</label>
//                 <textarea name="currentEmployerAddress" value={formData.currentEmployerAddress} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="2" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Nature of Business</label>
//                 <input type="text" name="natureOfBusiness" value={formData.natureOfBusiness} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Job Title</label>
//                 <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date Joined Organization</label>
//                 <input type="date" name="dateJoined" value={formData.dateJoined} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date Started Current Position</label>
//                 <input type="date" name="dateStartedCurrent" value={formData.dateStartedCurrent} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Notice Period Required</label>
//                 <input type="text" name="noticePeriod" value={formData.noticePeriod} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Current Salary / Salary When Left</label>
//                 <input type="text" name="currentSalary" value={formData.currentSalary} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Main Tasks and Responsibilities</label>
//                 <textarea name="mainTasks" value={formData.mainTasks} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="4" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Reason for Leaving (if no longer employed)</label>
//                 <textarea name="reasonForLeaving" value={formData.reasonForLeaving} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
//               </div>
//             </div>
//           </div>

//           {/* Employment History Continued */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Employment History (Continued)</h2>
//             <p className="text-sm text-gray-600 mb-4">List in chronological order, starting with most recent.</p>
//             {formData.employmentHistory.map((entry, index) => (
//               <div key={index} className="border p-4 mb-4 rounded">
//                 <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Employer's Name & Address</label>
//                     <textarea
//                       value={entry.employerName + '\n' + entry.employerAddress}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'employerName', e.target.value.split('\n')[0])}
//                       className="w-full p-2 border border-gray-300 rounded"
//                       rows="2"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Type of Business</label>
//                     <input
//                       type="text"
//                       value={entry.businessType}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'businessType', e.target.value)}
//                       className="w-full p-2 border border-gray-300 rounded"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Dates of Employment</label>
//                     <input
//                       type="text"
//                       value={entry.dates}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'dates', e.target.value)}
//                       className="w-full p-2 border border-gray-300 rounded"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Job Title/Role</label>
//                     <input
//                       type="text"
//                       value={entry.jobTitle}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'jobTitle', e.target.value)}
//                       className="w-full p-2 border border-gray-300 rounded"
//                     />
//                   </div>
//                   <div className="md:col-span-2">
//                     <label className="block text-sm font-medium text-gray-600">Reason for Leaving</label>
//                     <textarea
//                       value={entry.reasonForLeaving}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'reasonForLeaving', e.target.value)}
//                       className="w-full p-2 border border-gray-300 rounded"
//                       rows="2"
//                     />
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <button
//               type="button"
//               onClick={addEmploymentEntry}
//               className="bg-gray-500 hover:bg-gray-600 text-white py-1 px-3 rounded text-sm"
//             >
//               Add Another Entry
//             </button>
//           </div>

//           {/* Education and Training */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Education and Training</h2>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Secondary School Attended</label>
//                 <input type="text" name="secondarySchool" value={formData.secondarySchool} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Examinations Passed</label>
//                 <input type="text" name="secondaryExams" value={formData.secondaryExams} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Grades</label>
//                 <input type="text" name="secondaryGrades" value={formData.secondaryGrades} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-3">
//                 <label className="block text-sm font-medium text-gray-600">Further and Higher Education</label>
//                 <textarea name="furtherEducation" value={formData.furtherEducation} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Professional Organization</label>
//                 <input type="text" name="professionalOrg" value={formData.professionalOrg} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Grade of Membership</label>
//                 <input type="text" name="gradeOfMembership" value={formData.gradeOfMembership} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div className="md:col-span-3">
//                 <label className="block text-sm font-medium text-gray-600">Job-Related Training</label>
//                 <textarea name="jobTraining" value={formData.jobTraining} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="4" />
//               </div>
//             </div>
//           </div>

//           {/* Skills, Abilities */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Skills, Abilities and Supporting Information</h2>
//             <div className="mt-4">
//               <textarea
//                 name="skillsInfo"
//                 value={formData.skillsInfo}
//                 onChange={handleInputChange}
//                 className="w-full p-2 border border-gray-300 rounded"
//                 rows="6"
//                 placeholder="Provide evidence of skills, knowledge, and experience..."
//               />
//             </div>
//           </div>

//           {/* References */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">References</h2>
//             <p className="text-sm text-gray-600 mb-4">Provide details of two referees.</p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {/* Ref 1 */}
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-2">Referee 1</h3>
//                 <div className="space-y-2">
//                   <input type="text" name="ref1Name" value={formData.ref1Name} onChange={handleInputChange} placeholder="Name" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="text" name="ref1Company" value={formData.ref1Company} onChange={handleInputChange} placeholder="Company Name" className="w-full p-2 border border-gray-300 rounded" />
//                   <textarea name="ref1Address" value={formData.ref1Address} onChange={handleInputChange} placeholder="Full Address" className="w-full p-2 border border-gray-300 rounded" rows="2" />
//                   <input type="text" name="ref1JobTitle" value={formData.ref1JobTitle} onChange={handleInputChange} placeholder="Job Title" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="text" name="ref1Relationship" value={formData.ref1Relationship} onChange={handleInputChange} placeholder="Nature of Relationship" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="tel" name="ref1Phone" value={formData.ref1Phone} onChange={handleInputChange} placeholder="Phone" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="text" name="ref1Fax" value={formData.ref1Fax} onChange={handleInputChange} placeholder="Fax" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="email" name="ref1Email" value={formData.ref1Email} onChange={handleInputChange} placeholder="Email" className="w-full p-2 border border-gray-300 rounded" />
//                 </div>
//               </div>
//               {/* Ref 2 */}
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-2">Referee 2</h3>
//                 <div className="space-y-2">
//                   <input type="text" name="ref2Name" value={formData.ref2Name} onChange={handleInputChange} placeholder="Name" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="text" name="ref2Company" value={formData.ref2Company} onChange={handleInputChange} placeholder="Company Name" className="w-full p-2 border border-gray-300 rounded" />
//                   <textarea name="ref2Address" value={formData.ref2Address} onChange={handleInputChange} placeholder="Full Address" className="w-full p-2 border border-gray-300 rounded" rows="2" />
//                   <input type="text" name="ref2JobTitle" value={formData.ref2JobTitle} onChange={handleInputChange} placeholder="Job Title" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="text" name="ref2Relationship" value={formData.ref2Relationship} onChange={handleInputChange} placeholder="Nature of Relationship" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="tel" name="ref2Phone" value={formData.ref2Phone} onChange={handleInputChange} placeholder="Phone" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="text" name="ref2Fax" value={formData.ref2Fax} onChange={handleInputChange} placeholder="Fax" className="w-full p-2 border border-gray-300 rounded" />
//                   <input type="email" name="ref2Email" value={formData.ref2Email} onChange={handleInputChange} placeholder="Email" className="w-full p-2 border border-gray-300 rounded" />
//                 </div>
//               </div>
//             </div>
//             <p className="text-sm text-gray-500 mt-4 italic">Note: We will only contact referees with your prior agreement.</p>
//           </div>

//           {/* Personal Declaration */}
//           <div className="border-b pb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Personal Declaration</h2>
//             <p className="text-sm text-gray-600 mt-4 mb-4">
//               I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true. I understand that if I give any false or misleading information, and/or I am unable to provide specifically requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job). I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible to work in Nigeria and sight of original certificates, as detailed in my application.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Signature</label>
//                 <input type="text" name="signature" value={formData.signature} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date</label>
//                 <input type="date" name="date" value={formData.date} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       Print Styles - Add to your global CSS
//       {/* <style jsx global>{`
      
//       `}</style> */}
//     </div>
//   );
// };

// export default JobApplicationForm;



// JobApplicationForm.jsx
import React, { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';

const JobApplicationForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    // Personal Details
    positionAppliedFor: '',
    title: '',
    surname: '',
    firstName: '',
    otherNames: '',
    address: '',
    email: '',
    phoneNumber: '',
    preferredContact: '',
    unavailableDates: '',
    eligibleNigeria: '',
    eligibilityDocuments: '',
    criminalConvictions: '',
    unspentConvictionsDetails: '',
    
    // Employment History (Current)
    currentEmployerName: '',
    currentEmployerAddress: '',
    natureOfBusiness: '',
    jobTitle: '',
    dateJoined: '',
    dateStartedCurrent: '',
    noticePeriod: '',
    currentSalary: '',
    mainTasks: '',
    reasonForLeaving: '',
    
    // Employment History (Continued) - Array for multiple entries
    employmentHistory: [
      { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }
    ],
    
    // Education
    secondarySchool: '',
    secondaryExams: '',
    secondaryGrades: '',
    furtherEducation: '',
    professionalOrg: '',
    gradeOfMembership: '',
    jobTraining: '',
    
    // Skills
    skillsInfo: '',
    
    // References
    ref1Name: '',
    ref1Company: '',
    ref1Address: '',
    ref1JobTitle: '',
    ref1Relationship: '',
    ref1Phone: '',
    ref1Fax: '',
    ref1Email: '',
    ref2Name: '',
    ref2Company: '',
    ref2Address: '',
    ref2JobTitle: '',
    ref2Relationship: '',
    ref2Phone: '',
    ref2Fax: '',
    ref2Email: '',
    
    // Declaration
    signature: '',
    date: '',
  });

  const componentRef = useRef(null); // Initialize ref

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEmploymentHistoryChange = (index, field, value) => {
    const updatedHistory = formData.employmentHistory.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setFormData(prev => ({ ...prev, employmentHistory: updatedHistory }));
  };

  // Print functionality using react-to-print
  const handlePrint = useReactToPrint({
    content: () => {
      if (!componentRef.current) {
        console.error('Print content ref is not available');
        return null;
      }
      return componentRef.current;
    },
    onBeforeGetContent: () => {
      if (!componentRef.current) {
        alert('Error: Nothing to print. Please try again.');
        return Promise.reject('No content to print');
      }
      return Promise.resolve();
    },
    onPrintError: (errorLocation, error) => {
      console.error('Print error:', errorLocation, error);
      alert('Failed to initiate printing. Please try again.');
    }
  });

  // Download as PDF using html2pdf
  const handleDownload = () => {
    if (!componentRef.current) {
      alert('Error: Form content is not available for download.');
      return;
    }
    const element = componentRef.current;
    const opt = {
      margin: 1,
      filename: 'Job_Application_Form.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().set(opt).from(element).save();
  };

  // Add more employment history entries
  const addEmploymentEntry = () => {
    setFormData(prev => ({
      ...prev,
      employmentHistory: [...prev.employmentHistory, { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }]
    }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 m-4 max-w-4xl max-h-screen overflow-y-auto rounded-lg shadow-xl">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Job Application Form</h1>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
        </div>

        {/* Print/Download Buttons */}
        <div className="flex gap-4 mb-6">
          <button
            onClick={handlePrint}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
          >
            Print Form
          </button>
          <button
            onClick={handleDownload}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
          >
            Download PDF
          </button>
        </div>

        {/* Form Content - Ref for Print/Download */}
        <div ref={componentRef} className="space-y-8">
          {/* Position Applied For */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Position Applied For</h2>
            <input
              type="text"
              name="positionAppliedFor"
              value={formData.positionAppliedFor}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded mt-2"
              placeholder="Enter position applied for"
            />
          </div>

          {/* Personal Details */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Personal Details</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Title (Mr/Mrs/Miss/Ms)</label>
                <input type="text" name="title" value={formData.title} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Surname</label>
                <input type="text" name="surname" value={formData.surname} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">First Name(s)</label>
                <input type="text" name="firstName" value={formData.firstName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Any Other Names</label>
                <input type="text" name="otherNames" value={formData.otherNames} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Address</label>
                <textarea name="address" value={formData.address} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Email Address</label>
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Phone Number</label>
                <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Preferred Contact Method</label>
                <input type="text" name="preferredContact" value={formData.preferredContact} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Dates Not Available for Interview</label>
                <textarea name="unavailableDates" value={formData.unavailableDates} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="2" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Eligible for Employment in Nigeria?</label>
                <select name="eligibleNigeria" value={formData.eligibleNigeria} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded">
                  <option value="">Select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Documents for Eligibility</label>
                <textarea name="eligibilityDocuments" value={formData.eligibilityDocuments} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Criminal Convictions (Unspent)?</label>
                <select name="criminalConvictions" value={formData.criminalConvictions} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded">
                  <option value="">Select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Details of Unspent Convictions</label>
                <textarea name="unspentConvictionsDetails" value={formData.unspentConvictionsDetails} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
              </div>
            </div>
          </div>

          {/* Employment History (Current) */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Employment History - Current/Previous Employer</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Name of Company</label>
                <input type="text" name="currentEmployerName" value={formData.currentEmployerName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Address</label>
                <textarea name="currentEmployerAddress" value={formData.currentEmployerAddress} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="2" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Nature of Business</label>
                <input type="text" name="natureOfBusiness" value={formData.natureOfBusiness} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Job Title</label>
                <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Date Joined Organization</label>
                <input type="date" name="dateJoined" value={formData.dateJoined} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Date Started Current Position</label>
                <input type="date" name="dateStartedCurrent" value={formData.dateStartedCurrent} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Notice Period Required</label>
                <input type="text" name="noticePeriod" value={formData.noticePeriod} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Current Salary / Salary When Left</label>
                <input type="text" name="currentSalary" value={formData.currentSalary} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Main Tasks and Responsibilities</label>
                <textarea name="mainTasks" value={formData.mainTasks} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="4" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Reason for Leaving (if no longer employed)</label>
                <textarea name="reasonForLeaving" value={formData.reasonForLeaving} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
              </div>
            </div>
          </div>

          {/* Employment History Continued */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Employment History (Continued)</h2>
            <p className="text-sm text-gray-600 mb-4">List in chronological order, starting with most recent.</p>
            {formData.employmentHistory.map((entry, index) => (
              <div key={index} className="border p-4 mb-4 rounded">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Employer's Name & Address</label>
                    <textarea
                      value={entry.employerName + '\n' + entry.employerAddress}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'employerName', e.target.value.split('\n')[0])}
                      className="w-full p-2 border border-gray-300 rounded"
                      rows="2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Type of Business</label>
                    <input
                      type="text"
                      value={entry.businessType}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'businessType', e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Dates of Employment</label>
                    <input
                      type="text"
                      value={entry.dates}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'dates', e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Job Title/Role</label>
                    <input
                      type="text"
                      value={entry.jobTitle}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'jobTitle', e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-600">Reason for Leaving</label>
                    <textarea
                      value={entry.reasonForLeaving}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'reasonForLeaving', e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded"
                      rows="2"
                    />
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={addEmploymentEntry}
              className="bg-gray-500 hover:bg-gray-600 text-white py-1 px-3 rounded text-sm"
            >
              Add Another Entry
            </button>
          </div>

          {/* Education and Training */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Education and Training</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Secondary School Attended</label>
                <input type="text" name="secondarySchool" value={formData.secondarySchool} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Examinations Passed</label>
                <input type="text" name="secondaryExams" value={formData.secondaryExams} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Grades</label>
                <input type="text" name="secondaryGrades" value={formData.secondaryGrades} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-3">
                <label className="block text-sm font-medium text-gray-600">Further and Higher Education</label>
                <textarea name="furtherEducation" value={formData.furtherEducation} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="3" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Professional Organization</label>
                <input type="text" name="professionalOrg" value={formData.professionalOrg} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Grade of Membership</label>
                <input type="text" name="gradeOfMembership" value={formData.gradeOfMembership} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div className="md:col-span-3">
                <label className="block text-sm font-medium text-gray-600">Job-Related Training</label>
                <textarea name="jobTraining" value={formData.jobTraining} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" rows="4" />
              </div>
            </div>
          </div>

          {/* Skills, Abilities */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Skills, Abilities and Supporting Information</h2>
            <div className="mt-4">
              <textarea
                name="skillsInfo"
                value={formData.skillsInfo}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded"
                rows="6"
                placeholder="Provide evidence of skills, knowledge, and experience..."
              />
            </div>
          </div>

          {/* References */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">References</h2>
            <p className="text-sm text-gray-600 mb-4">Provide details of two referees.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Ref 1 */}
              <div>
                <h3 className="font-medium text-gray-700 mb-2">Referee 1</h3>
                <div className="space-y-2">
                  <input type="text" name="ref1Name" value={formData.ref1Name} onChange={handleInputChange} placeholder="Name" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="text" name="ref1Company" value={formData.ref1Company} onChange={handleInputChange} placeholder="Company Name" className="w-full p-2 border border-gray-300 rounded" />
                  <textarea name="ref1Address" value={formData.ref1Address} onChange={handleInputChange} placeholder="Full Address" className="w-full p-2 border border-gray-300 rounded" rows="2" />
                  <input type="text" name="ref1JobTitle" value={formData.ref1JobTitle} onChange={handleInputChange} placeholder="Job Title" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="text" name="ref1Relationship" value={formData.ref1Relationship} onChange={handleInputChange} placeholder="Nature of Relationship" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="tel" name="ref1Phone" value={formData.ref1Phone} onChange={handleInputChange} placeholder="Phone" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="text" name="ref1Fax" value={formData.ref1Fax} onChange={handleInputChange} placeholder="Fax" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="email" name="ref1Email" value={formData.ref1Email} onChange={handleInputChange} placeholder="Email" className="w-full p-2 border border-gray-300 rounded" />
                </div>
              </div>
              {/* Ref 2 */}
              <div>
                <h3 className="font-medium text-gray-700 mb-2">Referee 2</h3>
                <div className="space-y-2">
                  <input type="text" name="ref2Name" value={formData.ref2Name} onChange={handleInputChange} placeholder="Name" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="text" name="ref2Company" value={formData.ref2Company} onChange={handleInputChange} placeholder="Company Name" className="w-full p-2 border border-gray-300 rounded" />
                  <textarea name="ref2Address" value={formData.ref2Address} onChange={handleInputChange} placeholder="Full Address" className="w-full p-2 border border-gray-300 rounded" rows="2" />
                  <input type="text" name="ref2JobTitle" value={formData.ref2JobTitle} onChange={handleInputChange} placeholder="Job Title" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="text" name="ref2Relationship" value={formData.ref2Relationship} onChange={handleInputChange} placeholder="Nature of Relationship" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="tel" name="ref2Phone" value={formData.ref2Phone} onChange={handleInputChange} placeholder="Phone" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="text" name="ref2Fax" value={formData.ref2Fax} onChange={handleInputChange} placeholder="Fax" className="w-full p-2 border border-gray-300 rounded" />
                  <input type="email" name="ref2Email" value={formData.ref2Email} onChange={handleInputChange} placeholder="Email" className="w-full p-2 border border-gray-300 rounded" />
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-4 italic">Note: We will only contact referees with your prior agreement.</p>
          </div>

          {/* Personal Declaration */}
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold text-gray-700">Personal Declaration</h2>
            <p className="text-sm text-gray-600 mt-4 mb-4">
              I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true. I understand that if I give any false or misleading information, and/or I am unable to provide specifically requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job). I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible to work in Nigeria and sight of original certificates, as detailed in my application.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Signature</label>
                <input type="text" name="signature" value={formData.signature} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Date</label>
                <input type="date" name="date" value={formData.date} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded" />
              </div>
            </div>
          </div>
        </div>

        {/* Print Styles */}
        <style jsx global>{`
          @media print {
            body * { visibility: hidden; }
            .fixed, button { display: none !important; }
            div[ref="componentRef"] * { visibility: visible; }
            div[ref="componentRef"] { position: absolute; left: 0; top: 0; width: 100%; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default JobApplicationForm;